import router from '../../router'
export const mycontroller = {
  funcShuffle: (array) => {
    var currentIndex = array.length
    var temporaryValue
    var randomIndex
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex -= 1
      temporaryValue = array[currentIndex]
      array[currentIndex] = array[randomIndex]
      array[randomIndex] = temporaryValue
    }
    return array
  },
  numberWithCommas: (number) => {
    if (number !== undefined && number !== null) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
    return 0
  },
  convertToAlphabet: (charIndex, pos = 65) => {
    var alphanet = String.fromCharCode(pos + charIndex)
    return alphanet
  },
  doSanitizeTitle: (title) => {
    var slug = ''
    if (title !== '') {
      var titleLower = title.toLowerCase()
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      slug = slug.replace(/đ/gi, 'd')
      slug = slug.replace(/\s*$/g, '')
      slug = slug.replace(/\s+/g, '-')
      slug = slug.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '')
      slug = slug.replace(/\u02C6|\u0306|\u031B/g, '')
    }
    return slug
  },
  scrollViewToElement: (hashID) => {
    if (hashID !== null && hashID !== '') {
      setTimeout(function() { document.querySelector(hashID).scrollIntoView({behavior: 'smooth'}) }, 1000)
    }
  },
  stripHtml: (html) => {
    var tmp = document.createElement('div')
    tmp.innerHTML = html
    return tmp.innerText
  },
  compareArray: (arr1, arr2) => {
    let result = false
    if (!arr1 || !arr2) return result
    arr1.forEach((e1, i) => arr2.forEach(e2 => {
      if (e1.length > 1 && e2.length) result = this.compareArray(e1, e2)
      else if (e1 !== e2) result = false
      else result = true
    }))
    return result
  },
  encodeUtf8: (s) => {
    return unescape(encodeURIComponent(s))
  },
  getConfigFroala: (placeholder = 'Nhập ...', height = 248) => {
    return {
      placeholderText: placeholder,
      key: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2==',
      htmlUntouched: true,
      heightMin: height,
      autofocus: true
    }
  },
  getNowFull: ($spacer = '-', $date = '') => {
    var now = new Date()
    var today = new Date()
    if ($date !== '') today = new Date($date)
    var month = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)
    var day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
    const date = today.getFullYear() + $spacer + month + $spacer + day
    var hours = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
    var minutes = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
    var second = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
    const time = hours + ':' + minutes + ':' + second
    return date + ' ' + time
  },
  getNowDate: ($spacer = '-', $date = '') => {
    var today = new Date()
    if ($date !== '') today = new Date($date)
    var month = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)
    var day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
    return today.getFullYear() + $spacer + month + $spacer + day
  },
  getNowDateNotSecond: ($spacer = '-', $date = '') => {
    var now = new Date()
    var today = new Date()
    if ($date !== '') today = new Date($date)
    var month = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)
    var day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
    const date = day + $spacer + month + $spacer + today.getFullYear()
    var hours = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
    var minutes = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
    const time = hours + ':' + minutes
    const dateTime = date + ' ' + time
    return dateTime
  },
  getScrollTop: (element) => {
    if (element === window) return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
    return element.scrollTop
  },
  openStorage: (name) => {
    return localStorage.getItem(name)
  },
  saveLocalStorage: (name, value) => {
    localStorage.setItem(name, value)
  },
  clearStorage: (name) => {
    if (name !== '') localStorage.removeItem(name)
    else localStorage.clear()
  },
  redirectToPageBeforeLogin: (params) => {
    let name = params.name
    var nameCase = params.name.trim().toLowerCase()
    var landName = 'landing'
    var landing = nameCase.indexOf(landName)
    var landingCate = ''
    if (landing >= 0 && landName !== name) landingCate = nameCase.replace('landing_', '')
    if (params.url !== undefined && params.url !== null) {
      localStorage.setItem(params.likeName, params.object_id)
      setTimeout(() => {
        window.location.href = params.url
        router.go(0)
      }, 100)
    } else {
      if (landing >= 0) {
        var url = '/landing/' + params[0] + '-' + params.id
        if (landingCate.length > 0) url += '/' + landingCate
        router.push({path: url, params: params})
      } else {
        // console.log(name, params)
        router.push({name: name, params: params})
      }
    }
  },
  cleanAccents: (str) => {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
    str = str.replace(/đ/g, 'd')
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
    str = str.replace(/Đ/g, 'D')
    // Combining Diacritical Marks
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '')
    str = str.replace(/\u02C6|\u0306|\u031B/g, '')
    return str
  },
  removeByIndexFromString: (str, index) => {
    if (index === 0) return str.slice(1)
    else return str.slice(0, index - 1) + str.slice(index)
  },
  publicTeacher: (userID) => {
    router.push({name: 'account-view', params: {uid: userID}})
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/mycontroller.js